module.exports = __webpack_public_path__ + "img/ic_notification_play.40738b66.svg";